import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";

// Apis
import {
  downloadCampaignExcelReportFn,
  getCampaignPlan,
  getCampaignPlanOverview,
  removeCampaignPlanFilterFn,
  updateCampaignPlanStatus,
} from "../../apis/CampaignPlanAPI";

// Constants and Utils
import { ActionTypes } from "../../constants/ActionConstants";
import { getErrorMessage } from "../../utils/util";
import { constructRedirectPath } from "../../utils/redirect-utils/RedirectUtils";
import { CampaignState } from "../../prooh/pages/components/planningConstants";
import {
  FilenameExtensions,
  ReportConstants,
} from "../../constants/GeneralConstants";
import { saveFile } from "../../common-utils/file-utils/FileUtils";

// campaignPlanDetails for CITY
export function* getCampaignPlanDetails(action) {
  const { campaignId, cityId } = action.payload;
  try {
    const campaignPlan = yield getCampaignPlan(campaignId, cityId);

    yield put({
      type: ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN_SUCCESS,
      payload: { campaignPlan },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

// CampaignPlanDetails for CAMPAIGN
export function* getCampaignPlanOverviewDetails(action) {
  const { campaignId } = action.payload;
  try {
    const campaignPlanOverview = yield getCampaignPlanOverview(campaignId);

    yield put({
      type: ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN_OVERVIEW_SUCCESS,
      payload: { campaignPlanOverview },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN_OVERVIEW_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

// Update CampaignPlan State
export function* updatePlanStatus(action) {
  const {
    campaignId,
    status,
    history,
    redirectUrl,
    isMakeCampaignLive,
    isMakeCampaignCompleted,
  } = action.payload || {};

  try {
    yield updateCampaignPlanStatus(campaignId, status);

    // making campaign live
    if (isMakeCampaignLive) {
      yield updateCampaignPlanStatus(campaignId, CampaignState.LIVE);
    }

    // making campaign completed
    if (isMakeCampaignCompleted) {
      yield updateCampaignPlanStatus(campaignId, CampaignState.COMPLETED);
    }

    yield put({
      type: ActionTypes.CampaignPlanDetails.UPDATE_CAMPAIGN_PLAN_STATUS_SUCCESS,
    });

    history.push(constructRedirectPath(redirectUrl));
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: ActionTypes.CampaignPlanDetails.UPDATE_CAMPAIGN_PLAN_STATUS_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

// Remove Campaign Plan Filter
export function* removeCampaignPlanFilter(action) {
  const { campaignId, filtersObj } = action.payload;
  try {
    yield removeCampaignPlanFilterFn(campaignId, filtersObj);

    yield put({
      type: ActionTypes.CampaignPlanDetails.REMOVE_CAMPAIGN_PLAN_FILTER_SUCCESS,
    });
    toast.success("Removed Successfully");

    // TODO :: for now reloading the page to get latest data for full page (all apis)
    // reloading the page to get refreshed data for page"
    window.location.reload(true);
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: ActionTypes.CampaignPlanDetails.REMOVE_CAMPAIGN_PLAN_FILTER_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export function* downloadCampaignExcelReport(action) {
  try {
    const { campaignId, campaignTitle, isPureDooh = false } = action.payload;

    const data = yield downloadCampaignExcelReportFn(campaignId, isPureDooh);

    // file name
    const excelFileName = campaignTitle
      ? `${campaignTitle}${FilenameExtensions.xlsx}`
      : ReportConstants.CAMPAIGN_XLS_REPORT;

    // save file
    saveFile(excelFileName, data);

    yield put({
      type: ActionTypes.CampaignPlanDetails
        .DOWNLOAD_CAMPAIGN_PLAN_XLS_REPORT_SUCCESS,
      data: data,
    });
  } catch (err) {
    const errMsg = getErrorMessage(err);
    yield put({
      type: ActionTypes.CampaignPlanDetails
        .DOWNLOAD_CAMPAIGN_PLAN_XLS_REPORT_FAILURE,
      payload: err,
    });
    toast.error(errMsg);
  }
}

export default function* root() {
  yield all([
    takeLatest(
      ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN,
      getCampaignPlanDetails
    ),
    takeLatest(
      ActionTypes.CampaignPlanDetails.GET_CAMPAIGN_PLAN_OVERVIEW,
      getCampaignPlanOverviewDetails
    ),
    takeLatest(
      ActionTypes.CampaignPlanDetails.UPDATE_CAMPAIGN_PLAN_STATUS,
      updatePlanStatus
    ),
    takeLatest(
      ActionTypes.CampaignPlanDetails.REMOVE_CAMPAIGN_PLAN_FILTER,
      removeCampaignPlanFilter
    ),
    takeLatest(
      ActionTypes.CampaignPlanDetails.DOWNLOAD_CAMPAIGN_PLAN_XLS_REPORT,
      downloadCampaignExcelReport
    ),
  ]);
}
